// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1ug9Y","unreadBadge":"styles_unreadBadge__gkbMq","modalContent":"styles_modalContent__RtLBs","modal":"styles_modal__1Y2-z"};